import React, { useEffect } from 'react';
import { keyframes } from 'styled-components';
import { colors, styled } from '../../assets/theme';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';

interface IStateProps {
  id: number
  authToken: string
  currentEvent: any
}

interface IDispatchProps {
  pushGlobalEvent: (event: any, token: string) => void,
}

type Props = IStateProps & IDispatchProps

const EventsPanel: React.FunctionComponent<Props> = ({ id, authToken, currentEvent, pushGlobalEvent }) => {
  useEffect(() => {
    subscribeListener('widgets:events:global', id, ({ data: event }) => {
      if (event && event.message) pushGlobalEvent(event, authToken)
    });
    return () => unsubscribeListener('widgets:events:global', id);
  }, [id, pushGlobalEvent, authToken]);

  if (!currentEvent) return <div />

  return (
    <Panel color={colors.accents.bad.darker}>
      <Event color={colors.light.primary.base}>
        {currentEvent.getIn(['message', 'text'])}
      </Event>
    </Panel>
  );
};

const eventEffect = () => keyframes`
  0% {
    opacity: 0;
  }
  2% {
    opacity: 0;
    transform: translateY(-30px);
  }
  5% {
    opacity: 1;
    transform: translateY(0px);
  }
  50% {
    opacity: 1;
    transform: translateY(0px);
  }
  95% {
    opacity: 1;
    transform: translateY(0px);
  }
  98% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 0;
  }
`

const Panel = styled.div<{ color: string }>`
  background: ${(props) => props.color};
  display: grid;
  justify-content: center;
  padding: 0.5rem;
  position: absolute;
  width: 100vw;
  z-index: 1000;
`;

const Event = styled.div<{ color: string }>`
  animation: ${eventEffect()} 10s ease-in infinite;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${props => props.color};
`

export default EventsPanel;
